import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll'


const HomeSection = styled.section`
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	grid-row-gap: 4rem;
	padding-top: 10rem;
`

const Logo = styled.h1`
	font-size: 12rem;
	line-height: 0.9em;
	grid-column: 2 / span 2;
	grid-row: 3;
	letter-spacing: 0.05em;

	animation-name: fadeInUp;
	animation-duration: 0.6s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
	animation-timing-function: cubic-bezier(.2,.3,0,1)
    animation-delay: 1s;
    backface-visibility: hidden;
    perspective: 100px;
`


const Menu = styled.ul`
	position: fixed;
	text-align: right;
	list-style: none;
	line-height: 1.5em;
	right: 8rem;
	top: 8rem;
	z-index: 4;

	transform: translateX(50px);
 	opacity: 0;
	animation-name: fadeInLeft;
	animation-duration: 0.6s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
	animation-timing-function: cubic-bezier(.2,.3,0,1);
	animation-delay: 0.5s;
	backface-visibility: hidden;
    perspective: 100px;

	@media(max-width: 900px) {
		right: 8.33vw;
		top: 8.33vw;
	}
`

const MarqueeWrapper = styled.div`
	padding: 4rem 0;
	color: #FF6E6E;
	font-size: 5rem;
	grid-column: 1 / -1;
	grid-row: 1;
	overflow-x: hidden;
`

const Description = styled.p`
	grid-column: 8 / span 4;
	grid-row: 4;
	font-size: 4rem;
	line-height: 0.9em;
	
	transform: translateY(50px);
 	opacity: 0;	
	animation-name: fadeInUp;
	animation-duration: 0.6s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
	animation-timing-function: cubic-bezier(.2,.3,0,1);
	animation-delay: 0.6s;
	backface-visibility: hidden;
    perspective: 100px;

	@media(max-width: 900px) {
		grid-column: 3 / span 8;
		font-size: 3rem;
	}
`

const Line = styled.div`
	grid-column: 8;
	grid-row: 5 / span 2;
	width: 3px;
	background: #FFCA77;
	height: 20rem;

	transform: translateY(50px);
 	opacity: 0;
	animation-name: fadeInUp;
	animation-duration: 0.6s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
	animation-timing-function: cubic-bezier(.2,.3,0,1);
	animation-delay: 0.7s;
	backface-visibility: hidden;
    perspective: 100px;

	@media(max-width: 900px) {
		display: none;

	}
`

const Copyright = styled.span`
	grid-column: 3 / span 2;
	grid-row: 5;
	transform: translateY(50px);
 	opacity: 0;
	animation-name: fadeInUp;
	animation-duration: 0.6s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
	animation-timing-function: cubic-bezier(.2,.3,0,1);
	animation-delay: 0.8s;
	backface-visibility: hidden;
    perspective: 100px;
`

const Home = () => (
	<HomeSection id="home">
{/*		<MarqueeWrapper>
			arcadd is live • 
		</MarqueeWrapper>*/}
		
		<Logo>The<br/>Spice<br/>Rack</Logo>
		<Menu>
			<li><Link spy={true} smooth={true} duration={500} to="home">Home</Link></li>
			<li><Link spy={true} smooth={true} duration={500} to="streamers">Streamers</Link></li>
			<li><Link spy={true} smooth={true} duration={500} to="discord">Discord</Link></li>
			<li><Link spy={true} smooth={true} duration={500} to="about">About</Link></li>
		</Menu>
		<Description>
			Twitch streaming <br/>
			group & community
		</Description>
		<Line/>
		<Copyright>&copy; {new Date().getFullYear()}</Copyright>
	</HomeSection>
)

export default Home 



// WEBPACK FOOTER //
// ./src/compontents/home.js